<template>
   <div class="tabs-wrapper" :class="{ 'no-border': noBorder }">
      <ul class="tabs">
         <slot></slot>
      </ul>
      <div id="tab-actions">
         <slot name="actions"></slot>
      </div>
   </div>
</template>

<script setup lang="ts">
const props = defineProps({
   noBorder: { type: Boolean, default: false },
});
</script>

<style lang="scss">
@import "~/assets/scss/partials/tabs";
</style>
